import { useLocalization } from "@fluent/react";
import { BooleanFilter } from "./common";
import { FilterChips, FilterType } from "./filterConfig";

const AttachmentFilter = ({
  isActive,
  filters,
  handleSetFilter,
  handleSetActive,
  handleToggleFilter,
}: FilterType) => {
  const { l10n } = useLocalization();
  const label = l10n.getString("payment-activity-filter-attachments");
  const toggleLabel = l10n.getString(
    "payment-activity-filter-has-attachment",
  );

  return (
    <BooleanFilter
      isActive={isActive}
      filters={filters}
      handleSetFilter={handleSetFilter}
      handleSetActive={handleSetActive}
      handleToggleFilter={handleToggleFilter}
      filterName={FilterChips.ATTACHMENTS}
      label={label}
      toggleLabel={toggleLabel}
    />
  );
};

export default AttachmentFilter;
